import React from 'react'
import { Box, Grid } from '@mui/material'
import CustomText from '../CustomText/CustomText'
import { colors } from 'styles/colors'
import CustomButton from 'components/buttons/CustomButton/CustomButton'
import useStyles from './styles'

interface Props {
	title: string;
	description?: string;
	buttons?: React.ReactNode[];
	height?: number;
}

export default function PageHeader({ title, description, buttons = [], height = 50 }: Props) {
	const styles = useStyles()

	return (
		<Grid
			container
			className={styles.container}
			spacing={2}
			alignItems={{ xs: 'flex-start', md: 'center' }}
			justifyContent="space-between"
			height={height}
		>
			{/* Left: Text */}
			<Grid>
				<Box>
					<CustomText
						text={title}
						color={colors.primary}
						fontSize={22}
						fontWeight={700}
					/>

					{description && (
						<CustomText
							text={description}
							color={colors.secondary}
							fontSize={14}
						/>
					)}
				</Box>
			</Grid>

			{/* Right: Buttons */}
			<Grid
				display="flex"
				gap={1}
				flexWrap="wrap"
			>
				{buttons.map((item) => (item))}
			</Grid>
		</Grid>
	)
}
